function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRIWolontariat = function SvgRIWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M131.2 49.92h24.33v102.37H131.2z",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28 152.26H0V93.9c0-24.27 19.74-44.01 44.01-44.01h45.81v24.28H44.01c-10.88 0-19.73 8.85-19.73 19.73z",
    style: {
      fill: "#ffb900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2 1.3h24.3v24.3h-24.3z",
    style: {
      fill: "#e41f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgRIWolontariat;